import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import PlanActivity from "../planactivity";

const Share = lazy(() => import("../share"));
const Footer = lazy(() => import("../footer"));
const ActivitiesLayout = lazy(() => import("../activitieslayout"));
const ActivitiesProxy = lazy(() => import("../activitiesproxy"));

const App = () => {
  // User context is set in the ActivitesLayout component, nothing to do here
  
  return (
    <>
      <Routes>
        <Route path="/plan" element={<ActivitiesLayout />} >
          <Route index element={<ActivitiesProxy />} />
          <Route path="activity" >
            <Route path=":uuid" element={<PlanActivity />} />
          </Route>
        </Route>
        <Route path="/share" element={<ActivitiesLayout />} >
          <Route path="activity" >
            <Route path=":uuid" element={<Share />} />
          </Route>
        </Route>
        <Route path="/explore" element={<ActivitiesLayout />} >
          <Route index element={<ActivitiesProxy />} />
        </Route>
      </Routes>
      <Suspense fallback={<div>Loading...</div>}>
        <Footer />
      </Suspense>
    </>
  );
};

export default App;